module.exports = __webpack_public_path__ + "img/opiaid.3e6aa16d.png";